import React, {useEffect, useMemo, useRef, useState} from 'react'
import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl, FormHelperText,
    InputAdornment, Paper, Popper,
    Skeleton
} from "@mui/material";
import MDInput from "../../../components/MDInput";
import Autocomplete from "@mui/material/Autocomplete";
import {Trans, useTranslation} from "react-i18next";
import {useDebounce} from "use-debounce";
import {
    batch_Search, downloadBatchInfo,
    getAllWarehouseList, ownerSelected,
    skuProductSelected
} from "../../../actions/inventory/inventoryAction";
import LocalStorage from "../../../utils/LocalStorage";
import {useDispatch, useSelector} from "react-redux";
import {noop,isEqual} from "lodash";

import { zhCN,enUS } from '@mui/x-data-grid/locales';
import {Logout, onErrorAlert, onSuccessAlert, requisitionFilter} from "../../../actions";
import {useNavigate} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import MDButton from "../../../components/MDButton";
import DownloadIcon from "@mui/icons-material/Download";
import MDTypography from "../../../components/MDTypography";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {COLUMN_WIDTH} from "../../../constants";
import { v4 as uuidv4 } from 'uuid';
import CurrentStateLoading from "../../../examples/Loading/CurrentStateLoading";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {LoadingButton} from "@mui/lab";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";
import {MRT_Localization_FR} from "material-react-table/locales/fr";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";
import Fade from "@mui/material/Fade";
import Icon from "@mui/material/Icon";
import ClearIcon from "@mui/icons-material/Clear";
import Tour from "reactour";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {warehouse_List_owner} from "../../../actions/outbounds/outboundsAction";


const BatchSearch = React.memo(() => {

    const col = {  left: ['mrt-row-numbers','ownerId' ,'sku']}
    const mobileCol = { left: ['mrt-row-numbers'] }
    const mdCol = {  left: ['mrt-row-numbers','sku']}
    const {t, i18n} = useTranslation();
    const [sku,setSku] = useState([])
    const [skuAlias,setSkuAlias] = useState('')
    const [inputSkuValue,setInputSkuValue] = useState()
    const [value] = useDebounce(inputSkuValue, 500);
    const [valueAlias] = useDebounce(skuAlias, 500);
    const [skuList,setSkuList] = useState('')
    const [skusInput,setSkusInput] = useState('')
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [open, setOpen] = React.useState(false);

    // 新增：与“SKU Alias”对应的状态
    const [aliasList, setAliasList] = useState('');
    const [aliasesInput, setAliasesInput] = useState('');     // 最终存储选择的 alias 字符串（逗号分隔）
    const [aliasAnchorEl, setAliasAnchorEl] = useState(null);
    const [aliasOpen, setAliasOpen] = useState(false);
    const [aliasErrors, setAliasErrors] = useState({ error: false, message: '' });

    // 复用防抖：监听 aliasList 变化，检查行数限制
    const [popperAliasValue] = useDebounce(aliasList, 400);

    const [tourOpen,setTourOpen] = useState(false)
    const [currentStep, setCurrentStep] = useState(0);
    const [errors,setErrors] = useState({error:false,message:''})
    const [popperValue] = useDebounce(skuList, 400);
    const [isCopyOpen,setIsCopyOpen] = useState(false)
    const [preloaded, setPreloaded] = useState(false);
    const [dragState, setDragState] = useState({
        isDragging: false,
        startCell: null,
        endCell: null,
    });
    const [list,setList] =useState([])
    const [ownerList ,setOwnerList] =useState([])
    const [owner,setOwner] = useState([])
    const [inputOwnerValue,setInputOwnerValue] = useState()
    const [ownerValue] = useDebounce(inputOwnerValue, 500);
    const [warehouse, setWarehouse] = useState(null)
    const dispatch = useDispatch()
    const warehouseList = useSelector(state => state?.inventory?.warehouseList,(prev, next) => prev === next )
    const warehouseListOwner = useSelector(state => state?.outbounds?.warehouseListOwner,(prev, next) => prev === next)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });
    const [total,setTotal] = useState(0)
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next )
    const [data ,setData]= useState([])
    const nav = useNavigate()
    const [initialized, setInitialized] = useState(false);
    const [isAlertOpen,setIsAlertOpen] = useState(false)
    const haveCard = useSelector(state => state?.system?.haveCard,(prev, next) => prev === next )
    const [triggerFetch, setTriggerFetch] = useState(false);
    const lastPayloadRef = React.useRef(null);
    const initialLoad = React.useRef(true);
    // const [resetStatus ,setResetStatus] = useState(false)
    const [exportLoading,setExportLoading] = useState(false)
    const [loading, setLoading] = useState(false);
    const PAGE_KEY = 'inventory-stock-batch';
    const MOBILE_WIDTH = 600;
    const TABLET_WIDTH = 960;
    const getStoredColumnPinning = () => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        return storedData[PAGE_KEY] || null;
    };

    const [columnPinning, setColumnPinning] = useState(() => {
        const storedValue = getStoredColumnPinning();
        if (storedValue) return storedValue;

        // 按照默认逻辑走
        const width = window.innerWidth;
        if (width < MOBILE_WIDTH) return mobileCol;
        if (width < TABLET_WIDTH) return mdCol;
        return col;
    });

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem("columnPinning")) || {};
        if (JSON.stringify(storedData[PAGE_KEY]) !== JSON.stringify(columnPinning)) {
            storedData[PAGE_KEY] = columnPinning;
            localStorage.setItem("columnPinning", JSON.stringify(storedData));
        }
    }, [columnPinning]);

    const [columnVisibility, setColumnVisibility] = useState(() => {
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        return storedData[PAGE_KEY] || {
            ownerId:checkPermission(PERMISSION_DICT.QueryOwnerInfo),
            ownerName: checkPermission(PERMISSION_DICT.QueryOwnerInfo),
            productionDate:false,
            controlInventory:false,
            remark:false,
            supplierName:false,
            attribute1: false,
            attribute2: false,
        }; // 读取当前页面的列可见性
    })

    useEffect(() => {
        // 每次用户更改列显示状态时，存储到 localStorage
        const storedData = JSON.parse(localStorage.getItem('columnVisibility')) || {};
        storedData[PAGE_KEY] = columnVisibility; // 更新当前页面的列可见性
        localStorage.setItem('columnVisibility', JSON.stringify(storedData));
    }, [columnVisibility]);

    const headerRef = useRef(null);
    const [tableHeight, setTableHeight] = useState(640);

    useEffect(() => {
        const updateTableHeight = () => {
            if (headerRef.current) {
                const headerTop = headerRef.current.getBoundingClientRect().top;
                const newHeight = window.innerHeight - headerTop - 90;
                setTableHeight(newHeight > 200 ? newHeight : 200);
            }
        };

        const resizeObserver = new ResizeObserver(updateTableHeight);
        if (headerRef.current) {
            resizeObserver.observe(headerRef.current);
        }

        updateTableHeight(); // 初始化计算

        return () => resizeObserver.disconnect();
    }, []);

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    const handleOnFocusClick = (event) => {
        if( LocalStorage.getItem('batch_guide') && LocalStorage.getItem('batch_guide') === 'done'){
            setAnchorEl(event.currentTarget);
            setOpen((prev) => true);
            document.getElementById('sku_popper')?.focus()
        } else {
            setTourOpen(true)
        }


    };

    const steps = [
        {
            selector: '[data-tut="reactour_start"]',
            content: () => (
                <div>
                    <Trans i18nKey="PressFirstRowCopySku">
                        Press <strong>Shift</strong> and click the cell to select the first row to copy.
                    </Trans>
                </div>
            ),
        },
        {
            selector: '[data-tut="reactour_end"]',
            content: () => (
                <ul>
                    <li>
                        <Trans i18nKey="ReleaseLastRowCopySku">
                            Press <strong>Shift</strong> and click the cell to select the last row to copy
                        </Trans>
                    </li>
                    <li>
                        <Trans i18nKey="SelectedSkuYellowBorder"
                               components={{
                                   span: <span style={{ color: '#FFA726' }} />,
                                   strong: <strong />
                               }}
                        >
                            <strong>Double Click</strong> any <span>Yellow</span> border cell to copy the batch
                        </Trans>
                    </li></ul>
            ),
        },
        {
            selector: '[data-tut="reactour_step3"]',
            content: () => (
                <ul>
                    <li>
                        <Trans
                            i18nKey="PasteBatchSKUs"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                    <li>
                        <Trans
                            i18nKey="ClipboardToExcel"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                </ul>
            ),

        },
        {
            selector: '[data-tut="reactour_step4"]',
            content: () => (
                <ul>
                    <li>
                        <Trans
                            i18nKey="FilterDownCopySkus"
                            components={{
                                strong: <strong />
                            }}
                        >
                            <strong>Paste</strong> the batch SKUs into the input field
                        </Trans></li>
                </ul>
            ),
        }
    ];


    const handleSyncPopper = () => {
        let lines = skuList.split('\n')
        let skus =  lines.filter(v=> v!=='')
        let jointString = skus.join(",")
        if(errors.error){
            dispatch(onErrorAlert(t('ProductPage.The Input Cannot Exceed 200 SKUs')))
        } else {
            setSkusInput(jointString)
            setOpen(false)
        }


    }

    const handleSyncAliasPopper = () => {
        const lines = aliasList.split('\n').filter(v => v !== '');
        if (aliasErrors.error) {
            dispatch(onErrorAlert(t('ProductPage.The Input Cannot Exceed 200 SKUs')));
        } else {
            const jointString = lines.join(',');
            setAliasesInput(jointString);
            setAliasOpen(false);
        }
    };


    useEffect(()=>{
        if(currentStep === 1){
            setIsCopyOpen(true)
            setDragState({
                isDragging: false,
                startCell: {row:{index:0}},
                endCell: {row:{index:1}}
            })
        }

        if(currentStep === 3){
            const startRowIndex = Math.min(dragState.startCell.row.index, dragState.endCell.row.index);
            const endRowIndex = Math.max(dragState.startCell.row.index, dragState.endCell.row.index);


            const kitSkuData = data.slice(startRowIndex, endRowIndex + 1)
                .map(row => row['sku'])  // 假设'kitSku'是数据对象中对应列的键
                .join('\n');  // 使用换行符分隔，以便在复制到Excel等表格应用时形成单列

            let lines = kitSkuData.split('\n')
            let skus =  lines.filter(v=> v!=='')
            let jointString = skus.join(",")


            setSkusInput(jointString)

            // 复制到剪切板
            navigator.clipboard.writeText(kitSkuData)
                .then(() => dispatch(onSuccessAlert(`${t('ProductPage.Sku data copied to clipboard')}`)))
                .catch(err => dispatch(onErrorAlert((`${t('Failed to copy data')}: ${err}`))));
            setIsCopyOpen(false)
            setDragState({
                isDragging: false,
                startCell: null,
                endCell: null,
            })
        }
    },[currentStep])

    const closeTour = () => {
        setTourOpen(false);
        setCurrentStep(0); // 关闭时重置为第一步
        setSkusInput('')
        LocalStorage.setItem('batch_guide','done')
    };
    const openTour = () => {
        setCurrentStep(0); // 每次打开时从第一步开始
        setTourOpen(true);
        setPreloaded(true);
    };

    const skusPoppers = () => (
        <MDBox
            sx={{width:350}}
            role="presentation"
            display={'flex'}
            flexDirection={'column'}
            px={3}
            pb={3}
            justifyContent={'center'}
        >
            <Alert severity="info"
                   sx={{wordWrap:'break_word',whiteSpace:'normal',fontSize:'small',fontWeight:'medium'}}
                // action={
                //     <IconButton color="inherit" size="small">
                //         <DeleteIcon />
                //     </IconButton>
                // }
            >
                {t("ProductPage.Please enter the product SKUs in the input field below.Each SKU should be entered on a separate line.")}

            </Alert>

            <MDBox pt={1} pb={0} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2} sx={{minWidth: 250}}>
                        <FormControl
                            fullWidth
                            error={!!errors.error}
                        >
                            <MDInput
                                sx={{whiteSpace: "pre-wrap",overflowX:'auto','& textarea':{overflow:'auto'}}}
                                label={t('ProductPage.Enter Products SKUS, One Per Line')}
                                fullWidth
                                multiline
                                autoFocus={true}
                                variant="standard"
                                required
                                maxRows={5}
                                minLength={300}
                                InputLabelProps={{shrink: true}}
                                value={skuList}
                                onChange={(e) => setSkuList(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <IconButton
                                                size={'small'}
                                                aria-label='toggle password visibility'
                                                onClick={()=>{
                                                    setSkuList('')
                                                    setErrors({error: false,message:''})
                                                }}
                                                onMouseDown={()=>{
                                                    setSkuList('')
                                                    setErrors({error: false,message:''})
                                                }}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors?.error &&
                                <FormHelperText
                                    sx={{fontWeight: 'medium'}}>{errors?.message}
                                </FormHelperText>
                            }
                        </FormControl>

                    </Grid>
                </Grid>
            </MDBox>
            <MDBox display={'flex'} justifyContent={'flex-end'}>

                <MDButton size={'small'} variant={'outlined'} color="primary"  onClick={()=>setOpen(false)} disabled={!haveCard} sx={{marginRight:1}}>
                    {t('Close')}
                </MDButton>
                <MDButton size={'small'} variant={'gradient'} color="info"  onClick={handleSyncPopper} disabled={!haveCard}>
                    {t('Enter')}
                </MDButton>
            </MDBox>
        </MDBox>
    );
    const aliasesPoppers = () => (
        <MDBox
            sx={{ width: 350 }}
            role="presentation"
            display={'flex'}
            flexDirection={'column'}
            px={3}
            pb={3}
            justifyContent={'center'}
        >
            <Alert
                severity="info"
                sx={{ wordWrap: 'break_word', whiteSpace: 'normal', fontSize: 'small', fontWeight: 'medium' }}
            >
                {t("ProductPage.Please enter the product SKU Aliases in the input field below. Each alias on a separate line.")}
            </Alert>

            <MDBox pt={1} pb={0} px={3} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12} mb={2} sx={{ minWidth: 250 }}>
                        <FormControl fullWidth error={!!aliasErrors.error}>
                            <MDInput
                                sx={{ whiteSpace: "pre-wrap", overflowX: 'auto', '& textarea': { overflow: 'auto' } }}
                                label={t('ProductPage.Enter Products SKU Aliases, One Per Line')}
                                fullWidth
                                multiline
                                autoFocus={true}
                                variant="standard"
                                required
                                maxRows={5}
                                minLength={300}
                                InputLabelProps={{ shrink: true }}
                                value={aliasList}
                                onChange={(e) => setAliasList(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position='end'>
                                            <IconButton
                                                size={'small'}
                                                aria-label='clear alias list'
                                                onClick={() => {
                                                    setAliasList('');
                                                    setAliasErrors({ error: false, message: '' });
                                                }}
                                                onMouseDown={() => {
                                                    setAliasList('');
                                                    setAliasErrors({ error: false, message: '' });
                                                }}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {aliasErrors?.error && (
                                <FormHelperText sx={{ fontWeight: 'medium' }}>
                                    {aliasErrors?.message}
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
            </MDBox>

            <MDBox display={'flex'} justifyContent={'flex-end'}>
                <MDButton
                    size={'small'}
                    variant={'outlined'}
                    color="primary"
                    onClick={() => setAliasOpen(false)}
                    disabled={!haveCard}
                    sx={{ marginRight: 1 }}
                >
                    {t('Close')}
                </MDButton>
                <MDButton
                    size={'small'}
                    variant={'gradient'}
                    color="info"
                    onClick={handleSyncAliasPopper}
                    disabled={!haveCard}
                >
                    {t('Enter')}
                </MDButton>
            </MDBox>
        </MDBox>
    );

    useEffect(() => {
        document?.getElementById('sku_popper')?.focus()
        if(skusInput !==''){
            const str  = skusInput.split(",").map(sub=>sub.trim()).join("\n")
            setSkuList(str)
        } else {
            setSkuList('')
        }
        if(!open){
            setErrors({error:false,message:''})
        }
    }, [open]);

    useEffect(() => {
        if(skuList !== ''){

            let lines = skuList.split('\n')

            let skus =  lines.filter(v=> v!=='')
            if(skus.length > 200){
                setErrors({ error: true, message: `${t('You Already input')} ${skus.length} ${t('ProductPage.SKUs, The Input Cannot Exceed 200 SKUs')}` })
            } else {
                setErrors({ error: false, message: '' })
            }
        }

    }, [popperValue]);


    // 当 alias 弹出框打开时，用已有的 aliasesInput 生成多行；关闭时重置错误
    useEffect(() => {
        if (aliasesInput !== '') {
            const str = aliasesInput.split(',').map(sub => sub.trim()).join('\n');
            setAliasList(str);
        } else {
            setAliasList('');
        }
        if (!aliasOpen) {
            setAliasErrors({ error: false, message: '' });
        }
    }, [aliasOpen]);

// 检查 aliasList 行数不得超过 200 行（同 skus）
    useEffect(() => {
        if (aliasList !== '') {
            const lines = aliasList.split('\n').filter(v => v !== '');
            if (lines.length > 200) {
                setAliasErrors({
                    error: true,
                    message: `${t('You Already input')} ${lines.length} ${t('ProductPage.SKU Alias, The Input Cannot Exceed 200 SKU Aliass')}`
                });
            } else {
                setAliasErrors({ error: false, message: '' });
            }
        }
    }, [popperAliasValue]);

    const onCellMouseDown = (event,cell) => {

        event.stopPropagation();
        event.preventDefault();
        if (cell.column.id === 'sku' || cell.column.id === 'skuAlias') {
            setDragState({
                isDragging: true,
                startCell: cell,
                endCell: null,
            });
        }
    };

    const onCellMouseEnter = (event,cell) => {
        event.stopPropagation();
        event.preventDefault();
        if (dragState.isDragging && cell.column.id === dragState.startCell.column.id) {
            setDragState({
                ...dragState,
                endCell: cell,
            });
        }
    };

    const onCellMouseUp = (event) => {
        event.stopPropagation();  // 阻止事件冒泡
        event.preventDefault();
        let { startCell, endCell } = dragState;
        if (startCell && endCell && startCell.column.id === endCell.column.id) {
            if (startCell.row.index > endCell.row.index) {
                // 如果起始行大于结束行，交换它们
                [startCell, endCell] = [endCell, startCell];
            }

        }

        // 更新状态，结束拖拽
        setDragState({
            isDragging: false,
            startCell,
            endCell
        });
    };


    useEffect(() => {

        if(!dragState.isDragging && dragState.startCell && dragState.endCell){
            setIsCopyOpen(true)
        }
    }, [dragState]);

    
    const columns = [
            {
                accessorKey: 'ownerId',
                header: t('ownerId'),
                size: COLUMN_WIDTH.ownerId,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'ownerName',
                header: t('ownerName'),
                size:  COLUMN_WIDTH.ownerName,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),

            },
        {
            accessorKey: 'sku',
            header: t('ProductPage.sku'),
            id:'sku',
            size: 150,
            muiTableBodyCellProps: ({ row, cell }) => {

                let dataTutAttr = {};
                // 判断 data.length 是否大于等于 1，如果是，才添加 `data-tut` 属性
                if (data.length >= 2) {
                    if (row.index === 0) {
                        dataTutAttr = { 'data-tut': 'reactour_start' };
                    } else if (row.index === 1) {
                        dataTutAttr = { 'data-tut': 'reactour_end' };
                    }
                }
                const additionalClassName = row.index >= 0 && row.index <= 2 ? 'reactour_range' : '';

                return {
                    ...dataTutAttr,
                    className: additionalClassName,
                    sx: {
                        borderColor:
                            cell.column?.id === 'sku' &&                                      // 本单元格是 sku 列
                            dragState.startCell?.column?.id === 'sku' &&                       // 拖拽一定要从 sku 列开始
                            row.index >= (dragState.startCell?.row.index ?? -1) &&
                            row.index <= (dragState.endCell?.row.index ?? -1)
                                ? { borderColor: '#FFA726 !important' }
                                : {},
                        height: '30px',
                    },
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                    onMouseDown: (event) => onCellMouseDown(event,cell),
                    onMouseEnter: (event) => onCellMouseEnter(event,cell),
                    onMouseUp: (event) => onCellMouseUp(event),
                }

            },
        },
            // {
            //     accessorKey: 'skuAlias',
            //     header: t('ProductPage.skuAlias'),
            //     size: 170,
            //     muiTableBodyCellProps: ({ cell }) => ({
            //         onDoubleClick: (event) => {
            //             handleCellCopyClick(cell.getValue())
            //         },
            //     }),
            // },
        {
            accessorKey: 'skuAlias',
            header: t('ProductPage.skuAlias'),
            id: 'skuAlias',
            size: 170,
            muiTableBodyCellProps: ({ row, cell }) => {
                let dataTutAttr = {};
                // 这个例子里，如果你想给引导加 data-tut，可以加判断
                // if (data.length >= 2) { … 类似 sku 列 }
                const additionalClassName = row.index >= 0 && row.index <= 2 ? 'reactour_range' : '';

                return {
                    ...dataTutAttr,
                    className: additionalClassName,
                    sx: {
                        borderColor:
                            cell.column?.id === 'skuAlias' &&                                 // 本单元格是 skuAlias 列
                            dragState.startCell?.column?.id === 'skuAlias' &&                  // 拖拽一定要从 skuAlias 列开始
                            row.index >= (dragState.startCell?.row.index ?? -1) &&
                            row.index <= (dragState.endCell?.row.index ?? -1)
                                ? { borderColor: '#FFA726 !important' }
                                : {},
                        height: '30px',
                    },
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue());
                    },
                    onMouseDown: (event) => onCellMouseDown(event, cell),
                    onMouseEnter: (event) => onCellMouseEnter(event, cell),
                    onMouseUp: (event) => onCellMouseUp(event),
                };
            },
        },

        {
                accessorKey: 'productName',
                header: t('ProductPage.productName'),
                size: 150,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'warehouseDesc',
                header: t('Warehouse'),
                size: 150,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'qtyTotal',
                header: t('InventoryStockPage.Total Qty'),
                size: 120,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                // accessorKey: 'qtyAllocated',
                accessorKey: 'omsQtyAllocated',
                header: t("InventoryStockPage.Allocated"),
                size: 110,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
                Cell: ({ cell }) => (
                    <div>
                        {!!cell.getValue()?cell.getValue():'0'}
                    </div>
                )
            },
            {
                // accessorKey: 'qtyOnHold',
                accessorKey: 'omsQtyOnHold',
                header: t("InventoryStockPage.On Hold"),
                size: 100,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
                Cell: ({ cell }) => (
                    <div>
                        {!!cell.getValue()?cell.getValue():'0'}
                    </div>
                )
            },
            {
                accessorKey: 'productionDate',
                header: t('InventoryStockPage.Production'),
                size: 115,
                Cell: ({ cell }) => (
                    <div>
                        {cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD').toString():''}
                    </div>
                )
            },
            {
                accessorKey: 'expirationDate',
                header: t('InventoryStockPage.Expiration'),
                size: 110,
                Cell: ({ cell }) => (
                    <div>
                        {cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD').toString():''}
                    </div>
                )
            },
            {
                accessorKey: 'warehousingDate',
                header: t('InventoryStockPage.Warehousing'),
                size: 130,
                Cell: ({ cell }) => (
                    <div>
                        {cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD').toString():''}
                    </div>
                )
            },
            {
                accessorKey: 'supplierName',
                header: t('InventoryStockPage.Supplier'),
                size: 105,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'batchNo',
                header: t('InventoryStockPage.Batch No.'),
                size: 115,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'qualityCode',
                header: t('InventoryStockPage.Quality Status'),
                size: 140,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'controlInventory',
                header: t("InventoryStockPage.Control Inventory"),
                size: 155,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },
            {
                accessorKey: 'remark',
                header: t("InventoryStockPage.Remark"),
                size: 140,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),
            },

        {
            accessorKey: 'attribute1',
            header: t("ProductPage.Attribute 1"),
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'attribute2',
            header: t("ProductPage.Attribute 2"),
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        ]
    
    useEffect(()=>{
        const axiosPost = async () => {
            await dispatch(getAllWarehouseList(noop,onError))
            await dispatch(warehouse_List_owner(noop,onError))
        }
        haveCard && axiosPost().then()
        setInitialized(true);
    },[haveCard,languageSelect])

    useEffect(() => {
        return () => {
            lastPayloadRef.current = null
            initialLoad.current = true
            setData([])
            setTotal(0)
        };
    }, [dispatch]);

    useEffect(()=>{
        if(!checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            if(value){
                const axiosPost = async () => {
                    await dispatch(skuProductSelected({condition: value, userName: LocalStorage.getItem('username')}, (data)=>setList(data)))
                }
                haveCard && axiosPost().then()
            } else {
                setList([])
            }
        } else {
            if(value){
                const axiosPost = async () => {
                    await dispatch(skuProductSelected({condition: value, ownerIds:owner.map(ob => ob.ownerId), userName: LocalStorage.getItem('username')}, (data)=>setList(data)))
                }
                axiosPost().then()
            } else {
                setList([])
            }
        }

    },[value])


    useEffect(() => {
        if (initialized) {
            setSku([])
        }
    }, [owner]);
    useEffect(()=>{
        if(ownerValue){
            const axiosPost = async () => {
                await dispatch(ownerSelected({condition: ownerValue, userName: LocalStorage.getItem('username')}, (data)=>setOwnerList(data),onError))
            }
            haveCard && axiosPost().then()
        } else {
            setOwnerList([])
        }
    },[ownerValue])
    const saveFormData = () => {
        let formData = {}
        formData.condition = valueAlias
        formData.pageNum = (pagination.pageIndex + 1)
        formData.pageSize = pagination.pageSize
        formData.skus = skusInput === ''?[]: skusInput.split(",").map(sub=>sub.trim())
        formData.skuAliasList = aliasesInput === ''?[]: aliasesInput.split(",").map(sub=>sub.trim())
        formData.language = languageSelect
        if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            formData.ownerIds = []
        }
        // if(sku && sku?.length > 0){
        //     sku.forEach(v=>{
        //         formData.skus.push(v.sku)
        //     })
        // }
        if(owner && owner?.length > 0 && checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
            owner.forEach(v=>{
                formData.ownerIds.push(v.ownerId)
            })
        }
        //add admin
        formData.warehouseId = warehouse?.dictValue? warehouse?.dictValue:''
        formData.userName = LocalStorage.getItem('username')
        return formData
    }

    const onSuccess = (data) => {

        setTotal(data?.total ? data?.total:0)
        setData(data?.rows ? data?.rows.map((item, index) => {
            return { ...item, id: uuidv4() };
        }):[])
        setLoading(false)

    }


    useEffect(() => {
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        // console.log(lastPayloadRef.current,formData,lastPayloadRef.current === formData)

        if(initialLoad.current){
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(batch_Search(formData,onSuccess,onError))
            }
            haveCard && !loading && axiosPost().then()
            initialLoad.current = false
        } else if (isEqual(lastPayloadRef.current, formData) && !initialLoad.current) {
            return; // 如果 payload 相同，跳过请求
        } else {
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(batch_Search(formData,onSuccess,onError))
            }
            haveCard && !loading  && axiosPost().then()
            initialLoad.current = false
        }

        // 如果不同，更新 lastPayloadRef 并发送请求
        lastPayloadRef.current = formData;

    }, [pagination.pageIndex, pagination.pageSize, triggerFetch,languageSelect]);


    useEffect(() => {
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
    }, [aliasesInput,warehouse,skusInput,haveCard,owner]);
    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setExportLoading(false)
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const onDownloadSuccess = (msg) => {
        dispatch(onSuccessAlert(msg))
        setExportLoading(false)
    }
    function CustomerToolbar() {
        const handleClick = async () => {
            if (checkPermission(PERMISSION_DICT.QueryOwnerInfo) && owner.length === 0) {
                setIsAlertOpen(true)
                return
            }
            let formData = {}
            if (saveFormData()) {
                formData = saveFormData()
            } else {
                return nav('/')
            }
            setExportLoading(true)
            delete formData.pageNum;
            delete formData.pageSize;
            await dispatch(downloadBatchInfo(formData, onDownloadSuccess, onError))
        };

        const onLoadingClick = () => {
            const axiosPost = async () => {
                setLoading(true)
                await dispatch(batch_Search(saveFormData(),onSuccess,onError))
            }
            haveCard && axiosPost().then()
        }


        return (
            <MDBox sx={{display:'flex',flexWrap:'wrap',maxWidth:'100%'}}>
                <LoadingButton
                    sx={{color:'info'}}
                    loading={exportLoading}
                    loadingPosition="start"
                    startIcon={<DownloadIcon />}
                    variant="text"
                    onClick={handleClick} disabled={!(haveCard && checkPermission(PERMISSION_DICT.InventoryStockBatchExport))}
                >
                    {t("Export")}
                </LoadingButton>
                <CurrentStateLoading onLoadingClick={onLoadingClick} loading={loading}/>
                <MDButton variant={'text'} color="info" startIcon={<HelpOutlineIcon/>} onClick={openTour} disabled={data.length<6}>
                    {t('help')}
                </MDButton>
            </MDBox>
        );
    }




    const handleReset = () => {
        setOwner([]);
        setSku([]);
        setSkuList('');
        setSkusInput('');
        setSkuAlias('');      // 清空单行 SKU Alias 输入框
        setAliasesInput('');  // 清空逗号分隔的 Alias 字符串
        setAliasList('');     // 清空 Alias 弹窗里多行内容
        setWarehouse(null);
        setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        setTriggerFetch((prev) => !prev);
    };


    const table = useMaterialReactTable({
        enableColumnActions: false,
        columns,
        data, //must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        enableSorting: true,
        enableColumnPinning: true,
        onColumnPinningChange:setColumnPinning,
        getRowId: (row) => row.id,
        positionActionsColumn: 'last',
        enableRowNumbers: true,
        rowNumberDisplayMode: 'static',
        rowCount:total,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: true,
        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        localization:languageSelect === 'en'?MRT_Localization_EN:languageSelect === 'zh'?MRT_Localization_ZH_HANS:MRT_Localization_FR,
        initialState: {
            density: 'compact',
            // columnVisibility: {
            //     ownerId:checkPermission(PERMISSION_DICT.QueryOwnerInfo),
            //     ownerName: checkPermission(PERMISSION_DICT.QueryOwnerInfo),
            //     productionDate:false,
            //     controlInventory:false,
            //     remark:false,
            //     supplierName:false
            // },
            columnVisibility: {
                attribute1: false,
                attribute2: false,
                // …and any others you want forced-hidden initially
            },
        },
        onPaginationChange:setPagination,
        state: {
            pagination,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            columnPinning,
            columnVisibility
        },
        onColumnVisibilityChange:setColumnVisibility,
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({
            sx: (theme) => ({
                height:'30px',
                '&[data-pinned="true"]': {
                    backgroundColor: 'white !important',
                },
            }),
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {
                maxHeight: table.getState().isFullScreen ?  undefined:tableHeight,
            },
        }),
        renderTopToolbarCustomActions: CustomerToolbar,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                padding:'0px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: t('Search current page...'),
        }



    });

    return (<React.Fragment>
        <MDBox sx={{display: 'flex', justifyContent: 'center'}}>
            <Grid item container xs={12} px={5} pt={0} spacing={2}  alignItems={'flex-end'} >
                {
                    checkPermission(PERMISSION_DICT.QueryOwnerInfo) &&
                    <Grid item xs={12} md={3} >
                        <MDBox>
                            <FormControl fullWidth >
                                <Autocomplete
                                    multiple
                                    id="tags-standard"
                                    sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                    options={ownerList}
                                    getOptionLabel={(option) => `ID: ${option?.ownerId} Name: ${option?.ownerName}`}
                                    isOptionEqualToValue={(option, value) => option?.ownerId === value?.ownerId}
                                    value={owner}
                                    onChange={(e, v) => {
                                        // setResetStatus(false)
                                        setOwner(v)
                                    }}
                                    onInputChange = {(event, newInputValue)=> setInputOwnerValue(newInputValue)}
                                    renderInput={(params) => (
                                        <MDInput
                                            {...params}
                                            label={t('Owner ID or Name')}
                                            variant={'standard'}
                                        />
                                    )}
                                    noOptionsText={t('No Options')}
                                />
                            </FormControl>
                        </MDBox>
                    </Grid>
                }
                <Grid item xs={12} md={checkPermission(PERMISSION_DICT.QueryOwnerInfo) ? 3:3}>
                    <MDBox>
                        <FormControl fullWidth
                                     sx={(theme) => ( {"& .MuiTextField-root":{backgroundColor:'rgba(0,0,0,0)'}})}
                        >
                            <MDInput
                                label={t('ProductPage.Enter Batch SKUs')}
                                value={skusInput}
                                onChange={(e) => setSkusInput(e.target.value)}
                                variant={'standard'}
                                disabled={open}
                                InputProps={{
                                    endAdornment:
                                        <InputAdornment position="end">
                                            <Tooltip title={t('ProductPage.Click to display guide')}>
                                                <IconButton
                                                    size={'small'}
                                                    disabled={loading}
                                                    aria-label="Click to display guide"
                                                    onClick={()=> setTourOpen(true)}
                                                    edge="end"
                                                >
                                                    { <HelpIcon />}
                                                </IconButton>
                                            </Tooltip>

                                        </InputAdornment>,
                                    onFocus: handleOnFocusClick,
                                    inputProps: {
                                        'data-tut': 'reactour_step4', // 添加 data-tut 属性
                                    },
                                }}
                            />
                            <Popper
                                // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
                                sx={{ zIndex: 1200 }}
                                open={open}
                                disablePortal={true}
                                anchorEl={anchorEl}
                                placement={'top-end'}
                                transition
                                modifiers={[
                                    {
                                        name: 'flip',
                                        enabled: true,
                                        options: {
                                            altBoundary: true,
                                            rootBoundary: 'document',
                                            padding: 8,
                                        },
                                    },
                                    {
                                        name: 'preventOverflow',
                                        enabled: true,
                                        options: {
                                            altAxis: true,
                                            altBoundary: true,
                                            tether: true,
                                            rootBoundary: 'document',
                                            padding: 8,
                                        },
                                    },

                                ]}
                            >
                                {({ TransitionProps }) => (
                                    <Fade {...TransitionProps} timeout={200}>
                                        <Paper>
                                            <MDBox sx={{display:'flex', justifyContent:'flex-end'}}>
                                                <IconButton size="large" onClick={() => setOpen(false)}>
                                                    <Icon>cancel</Icon>
                                                </IconButton>
                                            </MDBox>
                                            {skusPoppers()}
                                        </Paper>
                                    </Fade>
                                )}
                            </Popper>
                        </FormControl>
                    </MDBox>
                </Grid>
                {/*<Grid item xs={12} md={checkPermission(PERMISSION_DICT.QueryOwnerInfo) ? 3:6} >*/}
                {/*    <MDBox>*/}
                {/*        <FormControl fullWidth >*/}
                {/*            <Autocomplete*/}
                {/*                multiple*/}
                {/*                id="tags-standard"*/}
                {/*                options={list}*/}
                {/*                sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}*/}
                {/*                getOptionLabel={(option) => `SKU: ${option.sku}   SKU Alias: ${option.skuAlias}`}*/}
                {/*                isOptionEqualToValue={(option, value) => option?.sku === value?.sku}*/}
                {/*                value={sku}*/}
                {/*                onChange={(e, v) => {*/}
                {/*                    // setResetStatus(false)*/}
                {/*                    setSku(v)*/}
                {/*                }}*/}
                {/*                onInputChange = {(event, newInputValue)=> setInputSkuValue(newInputValue)}*/}
                {/*                renderInput={(params) => (*/}
                {/*                    <MDInput*/}
                {/*                        {...params}*/}
                {/*                        label={t("InventoryStockPage.Product SKU")}*/}
                {/*                        variant={'standard'}*/}
                {/*                    />*/}
                {/*                )}*/}
                {/*                noOptionsText={t('No Options')}*/}
                {/*            />*/}
                {/*        </FormControl>*/}
                {/*    </MDBox>*/}
                {/*</Grid>*/}
                <Grid item xs={12} md={2}>
                    <MDBox>
                        <FormControl fullWidth >
                            {/*<MDInput*/}
                            {/*    label={t(`InventoryStockPage.Product SKU Alias`)}*/}
                            {/*    fullWidth*/}
                            {/*    value={skuAlias}*/}
                            {/*    onChange={(e) => {*/}
                            {/*        // setResetStatus(false)*/}
                            {/*        setSkuAlias(e.target.value)*/}
                            {/*    }}*/}
                            {/*    variant={'standard'}*/}
                            {/*/>*/}
                            <MDInput
                                label={t(`ProductPage.Enter (Batch) SKU Alias`)}
                                fullWidth
                                value={aliasesInput}
                                onChange={(e) => {
                                    setAliasesInput(e.target.value);
                                }}
                                variant={'standard'}
                                disabled={aliasOpen}
                                InputProps={{
                                    // endAdornment: (
                                    //     <InputAdornment position="end">
                                    //         <Tooltip title={t('Click to open Alias guide')}>
                                    //             <IconButton
                                    //                 size={'small'}
                                    //                 disabled={loading}
                                    //                 aria-label="Click to enter multiple SKU aliases"
                                    //                 onClick={(e) => {
                                    //                     // 先把已有 aliasesInput 转成多行 aliasList，然后打开 Popper
                                    //                     setAliasAnchorEl(e.currentTarget);
                                    //                     setAliasOpen(true);
                                    //                 }}
                                    //                 edge="end"
                                    //             >
                                    //                 <HelpIcon />
                                    //             </IconButton>
                                    //         </Tooltip>
                                    //     </InputAdornment>
                                    // ),
                                    onFocus: (e) => {
                                        // 和 onClick 一致，聚焦时也打开
                                        setAliasAnchorEl(e.currentTarget);
                                        setAliasOpen(true);
                                    },
                                    inputProps: {
                                        'data-tut': 'reactour_step_alias', // 如果后续要搞引导
                                    },
                                }}
                            />
                            <Popper
                                sx={{ zIndex: 1200 }}
                                open={aliasOpen}
                                disablePortal={true}
                                anchorEl={aliasAnchorEl}
                                placement={'top-end'}
                                transition
                                modifiers={[
                                    { name: 'flip', enabled: true, options: { altBoundary: true, rootBoundary: 'document', padding: 8 } },
                                    { name: 'preventOverflow', enabled: true, options: { altAxis: true, altBoundary: true, tether: true, rootBoundary: 'document', padding: 8 } },
                                ]}
                            >
                                {({ TransitionProps }) => (
                                    <Fade {...TransitionProps} timeout={200}>
                                        <Paper>
                                            <MDBox sx={{ display:'flex', justifyContent:'flex-end' }}>
                                                <IconButton size="large" onClick={() => setAliasOpen(false)}>
                                                    <Icon>cancel</Icon>
                                                </IconButton>
                                            </MDBox>
                                            {aliasesPoppers()}
                                        </Paper>
                                    </Fade>
                                )}
                            </Popper>


                        </FormControl>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={2} >
                    <MDBox>
                        <FormControl fullWidth >
                            <Autocomplete
                                required
                                disablePortal={false}
                                sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                // options={warehouseList}
                                options={
                                    checkPermission(PERMISSION_DICT.QueryOwnerInfo) ?
                                        warehouseList
                                        :
                                        warehouseList?.filter((ele)=>warehouseListOwner.find((v)=>v.dictValue === ele.dictValue))
                                }
                                getOptionLabel={(option) => `${option?.dictLabel}`}
                                isOptionEqualToValue={(option, value) => option?.dictValue === value?.dictValue}
                                value={warehouse}
                                onChange={(e, v) => {
                                    // setResetStatus(false)
                                    setWarehouse(v)
                                }}
                                renderInput={(params) =>
                                    <MDInput
                                        {...params}
                                        label={t("Select Warehouse")}
                                        variant={'standard'}
                                    />}
                            />
                        </FormControl>
                    </MDBox>
                </Grid>
                <Grid item xs={12} md={2} sx={{display:'flex',justifyContent:'flex-end'}}>
                    <MDButton sx={{marginLeft:1}} size={'small'} color="secondary" variant="outlined" startIcon={<CleaningServicesIcon />} disabled={!haveCard} onClick = {handleReset}>
                        {t('reset')}
                    </MDButton>
                </Grid>
            </Grid>
        </MDBox>
        <MDBox pb={0} mt={0} px={4} ref={headerRef}>
            <MaterialReactTable table={table} />
        </MDBox>
        <Dialog
            open={isAlertOpen}
            onClose={() => setIsAlertOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Export")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <MDTypography variant="h6" color="text">{t('At least one ownerID must be selected when exporting the report.')}</MDTypography>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={'outlined'} color="primary" onClick={() => setIsAlertOpen(false)}>{t('Close')}</MDButton>
            </DialogActions>
        </Dialog>
        <Dialog
            open={isCopyOpen || preloaded}
            onClose={() => setIsCopyOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth={'sm'}
            style={{ display: (isCopyOpen ? 'block' : 'none') }}

        >
            <DialogTitle id="alert-dialog-title">
                <div>{t("Are you sure?")}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {/*{dragState.endCell?.row?.index - dragState.startCell?.row?.index <= 200 ?*/}
                    {/*    `${t('ProductPage.Do you want to copy')} ${dragState.endCell?.row?.index - dragState.startCell?.row?.index + 1} ${t('ProductPage.SKUs to the clipboard?')}` :*/}
                    {/*    t('You cannot copy more than 200 SKUs at a time')*/}
                    {/*}*/}
                    {dragState.endCell?.row?.index - dragState.startCell?.row?.index <= 200 ? (
                      // 根据列 ID 显示不同提示
                          dragState.startCell?.column?.id === 'sku' ? (
                            `${t('ProductPage.Do you want to copy')} ${dragState.endCell.row.index - dragState.startCell.row.index + 1} ${t('ProductPage.SKUs to the clipboard?')}`
                          ) : (
                                `${t('ProductPage.Do you want to copy')} ${dragState.endCell.row.index - dragState.startCell.row.index + 1} ${t('ProductPage.SKU Alias to the clipboard?')}`
                              )
                        ) : (
                      // 超过 200 行时的统一提示
                          t('You cannot copy more than 200 items at a time')
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton onClick={() => {
                    setIsCopyOpen(false)
                    setDragState({
                        isDragging: false,
                        startCell: null,
                        endCell: null,
                    })
                }}>
                    {t('Cancel')}
                </MDButton>

                <MDButton
                    disabled={dragState.endCell?.row?.index - dragState.startCell?.row?.index > 200}
                    color={'primary'}
                    variant={'contained'}
                    data-tut="reactour_step3"
                    onClick={() => {
                        if (currentStep !== 0) return;

                        const startRowIndex = Math.min(dragState.startCell.row.index, dragState.endCell.row.index);
                        const endRowIndex = Math.max(dragState.startCell.row.index, dragState.endCell.row.index);

                        // 根据拖拽起始列 ID 决定要复制的字段：'sku' 或 'skuAlias'
                        const columnId = dragState.startCell.column.id; // 'sku' 或 'skuAlias'

                        // 把所选范围内对应列的值，用换行符拼起来
                        const rawData = data
                            .slice(startRowIndex, endRowIndex + 1)
                            .map(row => row[columnId])
                            .join('\n');

                        // 再把换行版拆成数组、过滤空行、拼成逗号分隔
                        const lines = rawData.split('\n').filter(v => v !== '');
                        const jointString = lines.join(',');

                        if (columnId === 'sku') {
                            setSkusInput(jointString);
                        } else if (columnId === 'skuAlias') {
                            setAliasesInput(jointString);
                        }

                        // 复制原始换行文本到剪贴板
                        navigator.clipboard
                            .writeText(rawData)
                            .then(() => {
                                const msg =
                                    columnId === 'sku'
                                        ? t('ProductPage.Sku data copied to clipboard')
                                        : t('ProductPage.SKU Alias data copied to clipboard');
                                dispatch(onSuccessAlert(msg));
                            })
                            .catch(err => dispatch(onErrorAlert(`${t('Failed to copy data')}: ${err}`)));

                        // 关闭弹窗并重置拖拽状态
                        setIsCopyOpen(false);
                        setDragState({
                            isDragging: false,
                            startCell: null,
                            endCell: null,
                        });
                    }}
                >
                    {t('YES')}
                </MDButton>

            </DialogActions>
        </Dialog>
        <Tour
            steps={steps}
            isOpen={tourOpen}
            startAt={currentStep}
            onRequestClose={closeTour}
            getCurrentStep={(step) => setCurrentStep(step)}
        />
    </React.Fragment>)
})
export default BatchSearch